export default __webpack_public_path__ + "static/media/global.e31b1f25.png";